/**
 * @file FilterRangeSeparator atom — the dash separator used between two range
 * inputs (min/max, from/to). Encapsulates the 7 px off-token width that has
 * no closed spacing-scale equivalent.
 * @module components/atoms/FilterRangeSeparator
 */

import React from "react";
import { StyleSheet, View } from "react-native";

import { Text } from "@/components/atoms/Text";

/** Props for the FilterRangeSeparator atom. */
export interface FilterRangeSeparatorProps {
  readonly testID?: string;
}

/**
 * Vertical dash separator between two range-filter inputs.
 * Width is 7 px — off the closed spacing scale (scale jumps px=1 → micro=2 → 1=4 → 2=8).
 * @param root0 - Component props
 * @param root0.testID - Test identifier
 */
export function FilterRangeSeparator({ testID }: FilterRangeSeparatorProps) {
  return (
    <View style={styles.separator} testID={testID}>
      <Text variant="unstyled" className="text-title-sm text-content-subtle">
        -
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  separator: {
    width: 7,
    alignSelf: "stretch",
    alignItems: "center",
    justifyContent: "center",
  },
});

FilterRangeSeparator.displayName = "FilterRangeSeparator";
